// TODO: Find fix for eslint-disable below and remove. (Alternate component to div for badge__inner due to accessibility issues)
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';

import { useClassName } from '@travpro/hooks';
import i18n from 'i18n-react';

import useIncentiveLink from 'hooks/useIncentiveLink';

const IncentiveBadge = ({
  badgeImg,
  title = '',
  active = false,
  rounded = true,
  onClick = () => {},
  microAppId = 0,
  lockLinkUrl = '',
}) => {
  const c = useClassName('incentiveBadge');

  const [incentiveLink, incentiveProgress] = useIncentiveLink(microAppId);

  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
  }

  if (microAppId === 0) {
    if (mobile) {
      return (
        <a onClick={() => window.ReactNativeWebView.postMessage(`internal-link:${lockLinkUrl}`)}>
          <div {...c()}>
            <img {...c('image', { inactive: !active, rounded })} src={badgeImg} alt={title} />
            <button type="button">{i18n.translate('trainingScreens.start')}</button>
          </div>
        </a>
      );
    }

    return (
      <a href={lockLinkUrl}>
        <div {...c()} onClick={onClick}>
          <img {...c('image', { inactive: !active, rounded })} src={badgeImg} alt={title} />

          {incentiveProgress === 0 && <button type="button">{i18n.translate('trainingScreens.start')}</button>}
          {incentiveProgress > 0 && incentiveProgress < 100 && (
            <button type="button">{i18n.translate('trainingScreens.continue')}</button>
          )}
          {incentiveProgress >= 100 && <button type="button">{i18n.translate('trainingScreens.completed')}</button>}
        </div>
      </a>
    );
  }
  if (mobile) {
    return (
      <a onClick={() => window.ReactNativeWebView.postMessage(`sub-app:${microAppId}`)}>
        <div {...c()}>
          <img {...c('image', { inactive: !active, rounded })} src={badgeImg} alt={title} />

          {incentiveProgress === 0 && <button type="button">{i18n.translate('trainingScreens.start')}</button>}
          {incentiveProgress > 0 && incentiveProgress < 100 && (
            <button type="button">{i18n.translate('trainingScreens.continue')}</button>
          )}
          {incentiveProgress >= 100 && <button type="button">{i18n.translate('trainingScreens.completed')}</button>}
        </div>
      </a>
    );
  }

  return (
    <a href={incentiveLink}>
      <div {...c()} onClick={onClick}>
        <img {...c('image', { inactive: !active, rounded })} src={badgeImg} alt={title} />

        {incentiveProgress === 0 && <button type="button">{i18n.translate('trainingScreens.start')}</button>}
        {incentiveProgress > 0 && incentiveProgress < 100 && (
          <button type="button">{i18n.translate('trainingScreens.continue')}</button>
        )}
        {incentiveProgress >= 100 && <button type="button">{i18n.translate('trainingScreens.completed')}</button>}
      </div>
    </a>
  );
};

IncentiveBadge.propTypes = {
  title: PropTypes.string,
  badgeImg: PropTypes.string.isRequired,
  active: PropTypes.bool,
  rounded: PropTypes.bool,
  lockLinkUrl: PropTypes.string,
  onClick: PropTypes.func,
  microAppId: PropTypes.number.isRequired,
  url: PropTypes.string,
};

export default IncentiveBadge;
